import styled from 'styled-components';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

interface Props {
  $open?: boolean;
  $currentRoute?: boolean;
}

export const SidebarIcon = styled(Icon) <Props>`
  width: 2rem;
  min-width: 2rem;
  margin: 0 0.25rem;
  color: ${props => (props.$currentRoute ? '#744cb4' : '#666')};
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 200ms;
`;

export const Sidebar = styled.li<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 3rem;
  width: 100%;
  padding: 0 0.5rem;
  background-color: ${props => (props.$currentRoute ? 'rgba(116, 76, 180, 0.1)' : 'transparent')};
  border-radius: 8px;
  border-left: ${props => (props.$currentRoute ? '4px solid #744cb4' : '4px solid transparent')};
  cursor: pointer;
  transition: all 200ms ease;
  text-decoration: none;
  color: inherit;
  box-shadow: none;

  &:hover {
    background-color: ${props => (props.$currentRoute ? 'rgba(116, 76, 180, 0.1)' : 'rgba(116, 76, 180, 0.05)')};
    border-radius: 8px;
    color: ${props => (props.$currentRoute ? props.theme.colors.primary : props.theme.colors.text)};
    box-shadow: 0 4px 12px rgba(116, 76, 180, 0.15);
  }
`;

export const SidebarTitle = styled.span<Props>`
  font-size: 14px;
  color: ${props => (props.$currentRoute ? '#744cb4' : '#333')};
  font-weight: ${props => (props.$currentRoute ? '500' : '400')};
  margin-left: 0.5rem;
  transition: 200ms;
  
  @media only screen and (min-width: 600px) {
    display: ${props => (props.$open ? 'inline' : 'none')};
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
  height: 100%;
`;
